<template>
  <div class="ssml-editor">
    <div class="ssml-form" v-show="showSettingForm">
      <div class="ssml-form-records">
        <div ref="records" :class="['ssml-form-record', {'active': key == currentIndex}]" v-for="(record, key) in records" :key="key" @keydown.delete="handleDelete(key)" @keyup.enter="handleEnter(key)" @paste.stop.prevent="handlePaste(key, $event)">
          <span>【{{getLangName(record.name)}}】</span>
          <el-input v-model="record.text" placeholder="在这里输入音频文本..." @focus="handleFocus(key)"></el-input>
        </div>
      </div>
      <div class="ssml-form-setting">
        <Setting v-model="records[currentIndex]"></Setting>
      </div>
    </div>
    <div class="ssml-xml-form" v-show="showCodeForm">
      <el-input type="textarea" v-model="ssmlCode" placeholder="在这里输入SSML代码，生成音频" :autosize="{minRows:15}" resize="none"></el-input>
    </div>
    <div class="actions">
      <i :class="['btn-video', playing ? 'el-icon-video-pause' : 'el-icon-video-play']" @click="handlePlay" title="试听生成的音频"></i>
      <i class="btn-open-code icon-round icon-text" @click="handleOpenCode" title="查看或修改SSML代码">&lt;/&gt;</i>
      <i class="el-icon-remove-outline" title="清空所有tts数据" @click="handleRemoveCode"></i>
      <i class="el-icon-magic-stick icon-round" title="一键清理多余的空格和标点符号" @click="handleCleanUpTtsCode"></i>
    </div>
    <div class="confirm">
      <el-button type="primary" @click="confirm">确认</el-button>
    </div>
    <div class="buiding" v-show="buiding">
      <i class="el-icon-loading"></i>
      <div class="message">音频正在生成中，请耐心等待...</div>
    </div>
    <audio ref="audio" :src="audioUrl" style="display:none;" @ended="handleAudioEnded"></audio>
  </div>
</template>

<script>
import config from './config'
import ssml from './ssml'
import Setting from './SSMLSetting.vue'
import _ from 'lodash'
import utils from '@/js/utils.js'

let defaultRecordSetting = {
  name: "",
  style: "default",
  styledegree: 1,
  role: "default",
  rate: "default",
  volume: "default",
  pitch: "default",
  text: "",
}

const defaultLangNames = _.fromPairs(config.langugages.map(n => [n.id, n.name]))

export default {
  name: 'SSMLEditor',
  components: { Setting },
  props: {
    value: String,
  },
  data() {
    return {
      records: [ {...defaultRecordSetting} ],
      currentIndex: 0,
      playing: false,
      ssmlCode: '',
      showSettingForm: true,
      showCodeForm: false,
      settingVer: 0,
      codeVer: 0,
      buiding: false,
      audio: '',
      audioVer: 0,
    }
  },
  computed: {
    audioUrl() {
      return this.audio ? utils.url(this.audio) : ''
    }
  },
  watch: {
    records: {
      handler(val, oldVal) {
        this.settingVer++
      },
      deep: true
    },
    ssmlCode() {
      this.codeVer++
    }
  },
  methods: {
    initTts() {
      if (this.audio === this.value) {
        return
      }
      this.audio = this.value
      console.log('init audio')
      if (!this.isEmpty()) {
        this.records = [ {...defaultRecordSetting} ]
      }
      this.audioVer = this.settingVer = this.codeVer = 0
      this.currentIndex = 0
      if (this.value) {
        console.log('load tts audio', this.value)
        this.$http.get('api/tts/info', {
          params: {
            url: this.value
          }
        }).then(res => {
          if (res.data.data) {
            const model = res.data.data
            this.ssmlCode = ssml.indent(model.code)
            this.records = ssml.parse(this.ssmlCode).map(t => {
              return {...defaultRecordSetting, ...t}
            })
            this.$nextTick(() => {
              this.audioVer = this.settingVer = this.codeVer = 1
            })
          }
        })
      }
    },
    isEmpty() {
      return (this.records.length === 1 && this.records[0].text === '') || this.records.length === 0
    },
    getLangName(id) {
      return defaultLangNames[id]
    },
    handleEnter(index) {
      const elInput = this.$refs.records[index].querySelector('input')
      const originalText = this.records[index].text
      this.records[index].text = originalText.substr(0, elInput.selectionStart)
      this.addRecord(index + 1, { text: originalText.substr(elInput.selectionEnd)})
      this.focus(index + 1)
    },
    handleFocus(index) {
      this.currentIndex = index
    },
    handlePaste(index, ev) {
      const text = ev.clipboardData.getData('text')
      if (!/^\s*$/.test(text)) {
        let values = text.split(/\r\n|\n/)
        const elInput = this.$refs.records[index].querySelector('input')
        const originalText = this.records[index].text
        values[values.length - 1] += originalText.substr(elInput.selectionEnd)
        this.records[index].text = originalText.substr(0, elInput.selectionStart) + values[0]
        if (values.length > 1) {
          let defaultRecord = {...defaultRecordSetting, ...this.records[index]}
          this.records.splice(index + 1, 0, ...values.splice(1).map(s => Object.assign({}, defaultRecord, { text: s})))
        }
      }
    },
    handleDelete(index) {
      if (this.records.length > 1 && this.records[index] && !this.records[index].text) {
        this.records.splice(index, 1)
        if (this.records.length <= this.currentIndex) {
          this.currentIndex = this.records.length - 1
          this.focus(this.currentIndex)
        }
      }
    },
    handleRemoveCode() {
      if (this.isEmpty()) {
        return true
      }
      this.currentIndex = 0
      this.records = [{...defaultRecordSetting}]
      this.ssmlCode = ''
      this.audio = ''
      this.$nextTick(() => {
        this.codeVer = this.settingVer = this.audioVer = 0
      })
    },
    focus(index) {
      window.setTimeout(() => {
        this.$refs.records[index].querySelector('input').focus()
      }, 1)
    },
    addRecord(index, val) {
      let record = {...defaultRecordSetting}
      if (this.records.length >= index && index > 0) {
        Object.assign(record, this.records[index - 1], { text: ''})
      }
      if (val) {
        Object.assign(record, val)
      }
      this.records.splice(index, 0, record)
    },
    removeRecord(index) {
      if (this.records.length > 1) {
        this.records.splice(index, 1)
        if (this.records.length <= this.currentIndex) {
          this.currentIndex = this.records.length - 1
        }   
      }
    },
    handlePlay() {
      this.playing = !this.playing
      if (this.playing) {
        this.ensureAudioUrl().then(res => {
          this.$nextTick(() => {
            this.$refs.audio.play()
          })
        }).catch(err => {
          console.log(err)
          this.playing = false
        })
      } else {
        this.$refs.audio.pause()
      }
    },
    handleAudioEnded() {
      this.playing = false
    },
    async ensureAudioUrl() {
      if (!this.audio || this.audioVer < this.settingVer || this.audioVer < this.codeVer) {
        const res = await this.buildAudio()
        this.audio = res.data.tts.url
        this.$nextTick(() => {
          this.audioVer = this.codeVer
        })
      }
      return this.audio
    },
    handleOpenCode() {
      this.showSettingForm = this.showCodeForm
      this.showCodeForm = !this.showCodeForm
      this.refreshSSMLContent()
    },
    refreshSSMLContent() {
      if (this.codeVer < this.settingVer) {
        this.ssmlCode = ssml.indent(ssml.output(this.records))
        this.$nextTick(() => {
          this.codeVer = this.settingVer
        })
      } else if (this.codeVer > this.settingVer) {
        this.records = ssml.parse(this.ssmlCode).map(t => {
          return {...defaultRecordSetting, ...t}
        })
        if (!this.records || this.records.length === 0) {
          this.records = [{...defaultRecordSetting}]
        }
        this.$nextTick(() => {
          this.settingVer = this.codeVer
        })
      }
    },
    buildAudio(ssmlCode) {
      if (ssmlCode === undefined) {
        this.refreshSSMLContent()
        ssmlCode = this.ssmlCode
      }
      if (!ssmlCode || /^\s*$/.test(ssmlCode) || !/>\s*[^<>\s]/.test(ssmlCode)) {
        return Promise.reject('无法为空的TTS配置生成音频')
      }
      // 移除所有开头和结尾的空白字符
      ssmlCode = ssml.cleanup(ssmlCode)
      this.buiding = true
      return this.$http.post('api/tts/edit', {
        sourceCode: ssmlCode,
        sourceField: '',
        sourceId: 0,
        field: '',
        id: 0,
      }).then(res => {
        this.buiding = false
        return res.data
      }).catch(err => {
        this.buiding = false
        return err
      })
    },
    handleCleanUpTtsCode() {
      this.refreshSSMLContent()
      this.records.forEach(n => {
        if (n.text) {
          n.text = n.text.replace(/([\u4e00-\u9fa5])\s+(?=[\u4e00-\u9fa5])/g, '$1').replace(/[^\u4e00-\u9fa5\w]+/g, ' ').replace(/^\s+|\s+$/g, '')
        }
      })
      this.$nextTick(this.refreshSSMLContent)
    },
    confirm() {
      if (this.records[this.currentIndex]) {
        defaultRecordSetting = {...this.records[this.currentIndex], text: ''}
      }
      this.ensureAudioUrl().then(url => {
        this.$emit('input', url)
      })
    }
  }
}
</script>

<style lang="scss">
.ssml-editor {
  position: relative;
  .ssml-form {
    display: flex;
  }
  .ssml-form-records {
    flex: 1;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    min-height: 356px;
    padding-right: 10px;
    .el-input__inner {
      border: 0;
      border-bottom: 1px solid #DCDFE6;
      border-radius: 0;
      padding-left: 0;
      padding-right: 0;
    }
    .ssml-form-record {
      display: flex;
      align-items: center;
      > span {
        white-space: nowrap;
      }
      input {
        background-color: transparent;
      }
      &.active, &:hover {
        background-color: #ecf5ff;
      }
    }
  }
  .ssml-form-setting {
    width: 200px;
    margin-left: 10px;
  }
  .ssml-xml-form {
    min-height: 356px;
  }
  .actions  {
    position: absolute;
    left: 0;
    bottom: 0;
    display: flex;
    font-size:32px;
    color: #606266;
    align-items: center;
    i {
      margin-right: 8px;
    }
    i:hover {
      color: #409eff;
      cursor: pointer;
    }
    .el-icon-video-pause {
      color: #409eff;
    }
    .icon-round {
      font-style: normal;
      font-size: 18px;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      border: 2px solid #606266;
      box-sizing: border-box;
      text-align: center;
      line-height: 24px;
      font-weight: bold;
      &:hover, &.active {
        color: #409eff;
        border-color: #409eff;
      }
      &.icon-text {
        font-size: 9px;
        display: block;
      }
    }
  }
  .confirm  {
    margin-top: 12px;
    text-align: right;
  }
  .buiding {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(#000, .5);
    color: white;
    z-index: 99;
    font-size: 48px;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .message {
      font-weight: normal;
      font-size: 24px;
      margin-top: 15px;
    }
  }
}
</style>